export default __webpack_public_path__ + "static/media/slide18.908a9c7b.png";